import React, { useEffect } from "react";
import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

const AdvisoryForInvestors = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <SEO
        title="Advisory for Investors"
        description="Official SEBI and Exchange advisories for investors. Learn about KYC compliance, risk management, and how to protect your investments from unauthorized schemes."
      />

      <section id="banner-slider" className="inn-banner-slider">
        <div
          id="carouselExampleIndicators"
          className="carousel slide"
          data-ride="carousel"
        >
          <div
            className="carousel-inner"
            role="group"
            aria-roledescription="carousel"
          >
            <div
              className="carousel-item active"
              role="group"
              aria-roledescription="slide"
              aria-label="1 of 1"
              style={{
                backgroundImage: "url('/images/other-banner.png')",
              }}
            >
              <canvas id="canvas"></canvas>
              <div className="carousel-caption">
                <h1>Advisory for Investors</h1>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="welcome-section">
        <div className="container">
          <div className="row justify-content-center">
            <div
              className="col-lg-12 text-left text-start"
              style={{ textAlign: "left" }}
            >
              <p>
                <b>
                  a. Awareness amongst clients/investors to abstain them from
                  dealing in any schemes of unauthorized collective
                  investments/portfolio management, indicative/ guaranteed/fixed
                  returns / payments
                </b>
              </p>
              <ul className="listitem" style={{ textAlign: "left" }}>
                <li>
                  Beware of fixed/guaranteed/regular returns/ capital protection
                  schemes. Brokers or their authorized persons or any of their
                  associates are not authorized to offer
                  fixed/guaranteed/regular returns/ capital protection on your
                  investment or authorized to enter into any loan agreement with
                  you to pay interest on the funds offered by you.
                </li>
                <li>
                  Please note that in case of default of a member claim for
                  funds or securities given to the broker under any arrangement/
                  agreement of indicative return will not be accepted by the
                  relevant Committee of the Exchange as per the approved norms.
                </li>
                <li>
                  Do not keep funds idle with the Stock Broker. Please note that
                  your stock broker has to return the credit balance lying with
                  them, within three working days in case you have not done any
                  transaction within last 30 calendar days. Please note that in
                  case of default of a Member, claim for funds and securities,
                  without any transaction on the exchange will not be accepted
                  by the relevant Committee of the Exchange as per the approved
                  norms.
                </li>
                <li>
                  Check the frequency of accounts settlement opted for. If you
                  have opted for running account, please ensure that your broker
                  settles your account and, in any case, not later than once in
                  90 days (or 30 days if you have opted for 30 days’
                  settlement).{" "}
                </li>
                <li>
                  <span>
                    In case of declaration of trading member as defaulter, the
                    claims of clients against such defaulter member would be
                    subject to norms for eligibility of claims for compensation
                    from IPF to the clients of the defaulter member. These norms
                    are available on Exchange website at following link:{" "}
                    <a
                      href="https://www.nseindia.com/invest/about-defaulter-section"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        wordBreak: "break-all",
                        overflowWrap: "anywhere",
                      }}
                    >
                      https://www.nseindia.com/invest/about-defaulter-section
                    </a>
                  </span>
                </li>
                <li>
                  Brokers are not permitted to accept transfer of securities as
                  margin. Securities offered as margin/ collateral MUST remain
                  in the account of the client and can be pledged to the broker
                  only by way of ‘margin pledge’, created in the Depository
                  system. Clients are not permitted to place any securities with
                  the broker or associate of the broker or authorized person of
                  the broker for any reason. Broker can take securities
                  belonging to clients only for settlement of securities sold by
                  the client.
                </li>
                <li>
                  Always keep your contact details viz. Mobile number/Email ID
                  updated with the stock broker. Email and mobile number is
                  mandatory and you must provide the same to your broker for
                  updation in Exchange records. You must immediately take up the
                  matter with Stock Broker/Exchange if you are not receiving the
                  messages from Exchange/Depositories regularly.
                </li>
                <li>
                  Don't ignore any emails/SMSs received from the Exchange for
                  trades done by you. Verify the same with the Contract
                  notes/Statement of accounts received from your broker and
                  report discrepancy, if any, to your broker in writing
                  immediately and if the Stock Broker does not respond, please
                  take this up with the Exchange/Depositories forthwith.
                </li>
                <li>
                  Check messages sent by Exchanges on a weekly basis regarding
                  funds and securities balances reported by the trading member,
                  compare it with the weekly statement of account sent by broker
                  and immediately raise a concern to the exchange if you notice
                  a discrepancy.
                </li>
                <li>
                  Please do not transfer funds, for the purposes of trading to
                  anyone, including an authorized person or an associate of the
                  broker, other than a SEBI registered Stock broker.
                </li>
              </ul>

              <p>
                <b>b. Advisory - KYC Compliance</b>
              </p>
              <ul className="listitem" style={{ textAlign: "left" }}>
                <li>
                  All investors are requested to take note that 6 KYC attributes
                  i.e. Name, PAN, Address, Mobile Number, Email id and Income
                  Range have been made mandatory. Investors availing custodian
                  services will be additionally required to update the custodian
                  details.
                </li>
                <li>
                  Investors may contact their respective stockbroker’s /
                  depository participants for updation of details in their
                  trading / demat account.
                </li>
                <li>
                  The last date to update KYC is on or before July 03, 2022.
                </li>
                <li>
                  Thereafter non-compliant trading accounts will be blocked for
                  trading by the Exchange.
                </li>
                <li>
                  The non-compliant demat accounts will be frozen for debits by
                  Depository Participant or Depository.
                </li>
                <li>
                  On submission of the necessary information to the stockbroker
                  and updation of the same by the stockbroker in the Exchange
                  systems and approval by the Exchange, the blocked trading
                  accounts shall be unblocked by the Exchange on T+1 trading
                  day.
                </li>
                <li>
                  The demat account shall be unfreezed once the investor submits
                  the deficient KYC details and the same is captured by the
                  depository participant in the depository system.
                </li>
                <li>
                  To ensure smooth settlement, the investors are requested to
                  ensure that both the trading and demat accounts are compliant
                  with respect to the KYC requirement. The investors are hereby
                  requested to comply with the regulatory guidelines issued by
                  Exchanges and Depositories from time to time with regard to
                  KYC compliance and related requirements.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section id="app-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 align-self-center">
              <h3>Download our Investment Fund App</h3>
              <p>Investing With Gateway Financial Services Limited</p>
              <a
                href="#download"
                className="lm-btn"
                onClick={(e) => e.preventDefault()}
              >
                download &amp; explore more
              </a>
            </div>
            <div className="col-lg-6">
              <img src="/images/app-pic.jpg" className="img-fluid" alt="App" />
            </div>
          </div>
        </div>
      </section>

      <FAQ />
    </div>
  );
};

export default AdvisoryForInvestors;
